export const navigation = [
    {name: 'How It Works', target: 'solution', link: "#solution"},
    {name: 'Documentation', target: 'documentation', link: "https://jigsaw.gitbook.io/jigsaw-protocol"},
    {name: 'Contact', target: 'contact', link: "https://x.com/jigsawdefi"},
];
